// Header.jsx
import "./style.css"; // import your global styles
import React, { useState } from "react";
const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    // Toggles the mobile nav
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    return (
        <header className="header">
            <nav className="navbar">
                <div className="nav-logo">
                    {/* Full URL to your homepage instead of "index.html" */}
                    <a href="https://seebreakthrough.com">
                        {/* Full URL for logo image */}
                        <img
                            src="https://seebreakthrough.com/images/Trophy Logo.png"
                            alt="SB Logo"
                            className="logo-img"
                        />
                    </a>
                </div>
                <button id="hamburgerBtn" onClick={toggleMenu} className="hamburger">
                    ☰
                </button>
                {/* Nav menu with conditional 'nav-open' class */}
                <div
                    id="navMenu"
                    className={`nav-menu ${menuOpen ? "nav-open" : ""}`}
                >
                    {/* Absolute links with #anchors */}
                    <a href="https://seebreakthrough.com/#features">Features</a>
                    <a href="https://seebreakthrough.com/#download">Download</a>
                    <a href="https://seebreakthrough.com/blog.html">Blog</a>
                </div>
            </nav>
        </header>
    );
};

export default Header;